import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "../../styles/components/product/ProductCard.module.css";

const ProductSkeleton = ({ view = "grid" }) => {
  const cardClass =
    view === "list" ? styles.productCardList : styles.productCardGrid;

  return (
    <div className={cardClass}>
      {view === "list" ? (
        <>
          <div className={styles.ListPicture}>
            <Skeleton height={80} width={80} />
          </div>
          <div className={styles.name}>
            <Skeleton height={20} width="100%" />
          </div>
          <div className={styles.ListmetaBlock}>
            <Skeleton height={15} width={60} />
            <Skeleton height={15} width={60} />
          </div>
          <div className={styles.price}>
            <Skeleton height={25} width={80} />
          </div>
        </>
      ) : (
        <>
          <Skeleton height={160} className={styles.skeletonMedia} />
          <Skeleton height={20} width="80%" className={styles.skeletonLine} />
          <Skeleton height={20} width="60%" />
        </>
      )}
    </div>
  );
};

export default ProductSkeleton;
